import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { CORE_ROUTE } from "@obg/ngx.core";
import { RouteLink } from "@obg/ngx.router";

@Component({
	selector: "obg-m-forgot-password-selection-container",
	styleUrls: ["./forgot-password-selection.container.scss"],
	templateUrl: "./forgot-password-selection.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordSelectionContainer {
	@HostBinding("class.obg-m-forgot-password-selection") hostCssClass = true;

	readonly resetPasswordByEmailRoute: RouteLink = {
		route: CORE_ROUTE.auth.resetPasswordByEmail,
	};
	readonly resetPasswordBySmsRoute: RouteLink = {
		route: CORE_ROUTE.auth.resetPasswordBySms,
	};
	readonly obgRouteLinkOptions = {
		queryParamsHandling: "preserve",
	};
}
